var map = {
	"./end-mobile.png": 7038,
	"./end.png": 3141,
	"./home.png": 3169,
	"./mute.png": 6935,
	"./pause.png": 9636,
	"./prize.png": 6118,
	"./rotate.png": 1173,
	"./settings.png": 5939,
	"./start.png": 6174,
	"./switch-camera.png": 4586,
	"./viewers.png": 5023
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9487;